import { useState } from "react";
import Button from "ui/buttons/Button";
import Drawer from "./Drawer";

A panel that slides in from the right over a dimmed backdrop. Built on Base UI Dialog, so it
handles Esc-to-close and accessibility automatically. It is product-agnostic — pass a `title` and
arbitrary `children`.

## Basic Usage

export function BasicDrawer() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open Drawer
      </Button>
      <Drawer open={open} onOpenChange={setOpen} title="Edit Mapping">
        <div style={{ padding: "18px 24px" }}>
          <p>Drawer content goes here.</p>
        </div>
      </Drawer>
    </>
  );
}

<BasicDrawer />

---

## With a Sub-Title

export function DrawerWithSubTitle() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open with sub-title
      </Button>
      <Drawer open={open} onOpenChange={setOpen} subTitle="Item" title="ITEM-1">
        <div style={{ padding: "18px 24px" }}>
          <p>The sub-title labels what kind of record the title names.</p>
        </div>
      </Drawer>
    </>
  );
}

<DrawerWithSubTitle />

---

## With Title Actions

export function DrawerWithActions() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open with actions
      </Button>
      <Drawer
        open={open}
        onOpenChange={setOpen}
        title="Edit Mapping"
        titleActions={
          <Button btnStyle="link" btnSize="small" onClick={() => setOpen(false)}>
            Save
          </Button>
        }
      >
        <div style={{ padding: "18px 24px" }}>
          <p>The header can host extra actions beside the close button.</p>
        </div>
      </Drawer>
    </>
  );
}

<DrawerWithActions />

---

## With a Footer

export function DrawerWithFooter() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open with footer
      </Button>
      <Drawer
        open={open}
        onOpenChange={setOpen}
        title="New item"
        footer={
          <>
            <Button btnStyle="secondary" btnSize="small" onClick={() => setOpen(false)}>
              Close
            </Button>
            <Button btnStyle="primary" btnSize="small" onClick={() => setOpen(false)}>
              Add item
            </Button>
          </>
        }
      >
        <div style={{ padding: "18px 24px" }}>
          <p>The footer stays pinned to the bottom while the body scrolls.</p>
        </div>
      </Drawer>
    </>
  );
}

<DrawerWithFooter />
